import * as React from 'react';
import styled from 'styled-components';
const StyledListItem = /*#__PURE__*/styled.li.withConfig({
  displayName: "ListItem__StyledListItem",
  componentId: "sc-1j6x76z-0"
})(["font-weight:300;"]);
const ListItem = props => {
  return /*#__PURE__*/React.createElement(StyledListItem, props, props.children);
};
export default ListItem;